export type Language = {
    myCharList: {
        loginTime: string;
    };
    commonBanner: {
        close: string;
        stop_watching: string;
    };
    autoSuggest: {
        deleteAllRecent: string;
        noRecentSearchHistory: string;
    }
};

export type AllLang = {
    [propName: string]: Language;
};

export const l10nAllLang: AllLang = {
    ko: {
        myCharList: {
            loginTime: '접속',
        },
        commonBanner: {
            stop_watching: '그만보기',
            close: '닫기',
        },
        autoSuggest: {
            deleteAllRecent: '최근 검색어 전체 삭제',
            noRecentSearchHistory: '최근 검색어 내역이 없습니다.',
        },
    },
    vi: {
        myCharList: {
            loginTime: 'Đăng nhập'
        },
        commonBanner: {
            stop_watching: 'Không hiển thị lại',
            close: 'Đóng',
        },
        autoSuggest: {
            deleteAllRecent: 'Không có cụm từ tìm kiếm gần đây.',
            noRecentSearchHistory: 'Xóa tất cả tìm kiếm gần đây',
        },
    },
    zh: {
        myCharList: {
            loginTime: '連線',
        },
        commonBanner: {
            stop_watching: '不再顯示',
            close: '關閉',
        },
        autoSuggest: {
            deleteAllRecent: '刪除近期所有關鍵字',
            noRecentSearchHistory: '沒有最近的查詢關鍵字。',
        },
    },
    ja: {
        myCharList: {
            loginTime: '接続',
        },
        commonBanner: {
            stop_watching: '表示しない',
            close: '閉じる',
        },
        autoSuggest: {
            deleteAllRecent: '検索ワード履歴削除',
            noRecentSearchHistory: '最近の検索ワードはありません。',
        },
    },
    en: {
        myCharList: {
            loginTime: 'Login',
        },
        commonBanner: {
            stop_watching: 'Do not show again.',
            close: 'Close',
        },
        autoSuggest: {
            deleteAllRecent: 'Delete All Recent Searches',
            noRecentSearchHistory: 'No recent search history.',
        },
    },
    th: {
        myCharList: {
            loginTime: 'เชื่อมต่อ',
        },
        commonBanner: {
            stop_watching: 'ไม่แสดงอีก',
            close: 'ปิด',
        },
        autoSuggest: {
            deleteAllRecent: 'ลบคำค้นหาล่าสุดทั้งหมด',
            noRecentSearchHistory: 'ไม่มีข้อมูลคำค้นหาล่าสุด',
        },
    },
    ru: {
        myCharList: {
            loginTime: 'Войти',
        },
        commonBanner: {
            stop_watching: 'Больше не показывать',
            close: 'Закрыть',
        },
        autoSuggest: {
            deleteAllRecent: 'Удалить историю поиска',
            noRecentSearchHistory: 'Отсутствует история поиска.',
        },
    },
    id: {
        myCharList: {
            loginTime: 'Sambungkan',
        },
        commonBanner: {
            stop_watching: 'Jangan tampilkan',
            close: 'Tutup',
        },
        autoSuggest: {
            deleteAllRecent: 'Hapus Riwayat Pencarian Terbaru',
            noRecentSearchHistory: 'Tidak ada riwayat pencarian terbaru.',
        },
    },
    ar: {
        myCharList: {
            loginTime: 'تسجيل الدخول',
        },
        commonBanner: {
            stop_watching: 'لا تظهر مرة أخرى.',
            close: 'أغلق',
        },
        autoSuggest: {
            deleteAllRecent: 'حذف كل مصطلحات البحث الحديثة',
            noRecentSearchHistory: 'لا يوجد تفاصيل بحث حديثة.',
        },
    },
};
